import axios from "axios";

export function getApplications() {
    return {
        type: "GET_APPLICATIONS",
        payload: axios.get("/rest/application")
    }
}

export function createApplication(application) {
    return {
        type: "CREATE_APPLICATION",
        meta: {
            application,
        },
        payload: axios.post("/rest/application/" + application.contest.id)
    }
}

export function sendApplication(application) {
    return {
        type: "SEND_APPLICATION",
        meta: {
            application,
        },
        payload: axios.post("/rest/application/" + application.id + "/send")
    }
}

export function deleteApplication(application) {
    return {
        type: "DELETE_APPLICATION",
        meta: {
            application,
        },
        payload: axios.delete("/rest/application/" + application.id)
    }
}

export function revertApplication(application) {
    return {
        type: "REVERT_APPLICATION",
        meta: {
            application,
        },
        payload: axios.post("/rest/application/" + application.id + "/revert")
    }
}

export function getApplication(applicationId) {
    return {
        type: "GET_APPLICATION",
        payload: axios.get("/rest/application/" + applicationId)
    }
}

export function editSoloCategory(category) {
    return {
        type: "EDIT_SOLO_CATEGORY",
        category
    }
}

export function addPresentation(category) {
    return {
        type: "ADD_PRESENTATION",
        category,
        presentation: {
            id: 0,
            name: "",
            participants: []
        }
    }
}

export function editPresentation(category, presentation) {
    return {
        type: "EDIT_PRESENTATION",
        category,
        presentation
    }
}

export function deletePresentation(category, presentation) {
    return {
        type: "DELETE_PRESENTATION",
        meta: {
            category,
            presentation
        },
        payload: axios.delete("/rest/presentation/" + presentation.id)
    }
}

export function savePresentation(application, category, presentation) {
    return {
        type: "SAVE_PRESENTATION",
        payload: presentation.id ? axios.put("/rest/presentation/" + presentation.id, {
            name: presentation.name,
            participants: presentation.participants.map(p => p.id)
        }) : axios.post("/rest/presentation", {
            application: application.id,
            category: category.id,
            name: presentation.name,
            participants: presentation.participants.map(p => p.id)
        })
    }
}

export function cancelEdit() {
    return {
        type: "CANCEL_EDIT"
    }
}

export function updatePresentationName(value) {
    return {
        type: "UPDATE_PRESENTATION_NAME",
        value
    }
}

export function removeParticipant(participant) {
    return {
        type: "REMOVE_PARTICIPANT_FROM_PRESENTATION",
        participant
    }
}

export function addParticipant(participant) {
    return {
        type: "ADD_PARTICIPANT_TO_PRESENTATION",
        participant
    }
}

export function removeSoloParticipant(participant) {
    return {
        type: "REMOVE_PARTICIPANT_FROM_SOLO_CATEGORY",
        participant
    }
}

export function addSoloParticipant(participant) {
    return {
        type: "ADD_PARTICIPANT_TO_SOLO_CATEGORY",
        participant
    }
}

export function saveSoloCategory(application, category, participants) {
    return {
        type: "SAVE_SOLO_CATEGORY",
        payload: axios.post("/rest/presentation/solo", {
            application: application.id,
            category: category.id,
            participants: participants.map(p => p.id)
        })
    }
}

export function updateParticipantSearchText(value) {
    return {
        type: "UPDATE_PARTICIPANT_SEARCH_TEXT",
        value
    }
}

export function clearErrors() {
    return {
        type: "CLEAR_ERRORS"
    }
}

export function getApplicationPayments(applicationId) {
    return {
        type: "GET_APPLICATION_PAYMENTS",
        payload: axios.get("/rest/application/" + applicationId + "/payments")
    }
}


// WEBPACK FOOTER //
// ./src/actions/application.js